<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <v-data-table
        dense
        :headers="headers"
        :items="userProfiles"
        :footer-props="{
          'items-per-page-options': [25, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
      />
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";

import { formatDate } from "../../functions/format";

export default {
  name: "RestHomeUserProfile",

  data() {
    return {
      headers: [
        { text: "Nome", value: "name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],

      rest_home_id: "",

      userProfiles: [],

      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,

    retrieve() {
      const { id } = this.$attrs;

      this.rest_home_id = id;

      this.getUserProfiles();
    },
    async getUserProfiles(page = 1) {
      try {
        this.loading = true;

        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          page,
        };

        const response = await api.get("/admin/rest-home/profiles/paginate", {
          params,
        });

        const { profiles } = response.data;

        this.userProfiles = profiles;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>